import { emptyAddressFields, emptyDeliveryAddressFields, getAddressValidationSchema, hasPrefilledAddress, isStoreDeliveryAddress, } from '../../form/address-fields/addressFields.utils';
import { CountryId, } from '@as-react/common-types';
import CustomerUtil from '../../../util/CustomerUtil';
import { getCustomerDetailsValidationSchema } from '../../form/registration-fields/CustomerDetailsFields.utils';
export const initialValuesDeliveryForm = {
    chosenDeliveryOption: undefined,
    delivery: {
        address: emptyDeliveryAddressFields,
        saveAddress: false,
        showCustomTown: false,
    },
    customer: {
        idTitle: undefined,
        firstName: '',
        middleName: '',
        lastName: '',
        address: emptyDeliveryAddressFields,
    },
    needInvoice: false,
    alternateInvoiceAddress: false,
    invoice: {
        vatCountry: '',
        vatNumber: '',
        companyName: '',
        companyDepartment: '',
        techAddress: '',
        address: emptyAddressFields,
    },
};
export const getDeliveryAddressValidationSchema = ({ t, country }) => getAddressValidationSchema({ t, country }).concat(getCustomerDetailsValidationSchema({ t }));
export const getPreselectedAddress = ({ deliveryAddress, deliveryAddresses, idCountry }, selectedAddress) => {
    if (selectedAddress && selectedAddress.idCountry === idCountry) {
        return selectedAddress;
    }
    const defaultAddress = deliveryAddresses === null || deliveryAddresses === void 0 ? void 0 : deliveryAddresses.find(address => address.defaultAddress);
    const address = defaultAddress
        ? defaultAddress
        : hasPrefilledAddress(deliveryAddress) &&
            deliveryAddress.idCountry === idCountry &&
            !isStoreDeliveryAddress(deliveryAddress)
            ? deliveryAddress
            : deliveryAddresses === null || deliveryAddresses === void 0 ? void 0 : deliveryAddresses[0];
    return (address === null || address === void 0 ? void 0 : address.idCountry) === idCountry ? address : undefined;
};
const setCustomerDetailsPhoneNumber = (value) => CustomerUtil.convertPhoneNumberPrefix(value, '+', '00');
export const getInitialValues = (delivery, initValues, selectedAddress, optionName, idCountry) => {
    var _a;
    if (!delivery || !(delivery === null || delivery === void 0 ? void 0 : delivery.customerDetails)) {
        return Object.assign(Object.assign({}, initValues), { chosenDeliveryOption: optionName });
    }
    const { deliveryAddress, customerDetails } = delivery;
    const preselectedAddress = getPreselectedAddress(delivery, selectedAddress);
    const address = preselectedAddress && preselectedAddress.idCountry === idCountry
        ? preselectedAddress
        : ((_a = customerDetails.address) === null || _a === void 0 ? void 0 : _a.idCountry) === idCountry
            ? customerDetails.address
            : emptyDeliveryAddressFields;
    const customerAddress = Object.assign(Object.assign({}, initValues.customer.address), customerDetails.address);
    let initialValues = Object.assign(Object.assign(Object.assign(Object.assign({}, initValues), { chosenDeliveryOption: delivery.chosenDeliveryOption || undefined }), setInvoiceValues(customerDetails, idCountry)), { delivery: Object.assign(Object.assign({}, initValues.delivery), { address: Object.assign(Object.assign(Object.assign(Object.assign({}, CustomerUtil.getCustomerNames(delivery, optionName)), address), updateAddressCountryValues(address, idCountry)), { addToProfile: false, idCountry: idCountry, phoneNumber: deliveryAddress.phoneNumber || customerDetails.mobilePhoneNumber
                    ? CustomerUtil.convertPhoneNumberPrefix(deliveryAddress.phoneNumber || customerDetails.mobilePhoneNumber, '00', '+')
                    : undefined }) }), customer: Object.assign(Object.assign(Object.assign({}, initValues.customer), CustomerUtil.getCustomerNames(delivery, optionName)), { address: Object.assign(Object.assign(Object.assign({}, customerAddress), updateAddressCountryValues(customerAddress, idCountry)), { idCountry: idCountry }) }) });
    const phoneNumber = deliveryAddress.phoneNumber || customerDetails.mobilePhoneNumber;
    if (phoneNumber) {
        initialValues = Object.assign(Object.assign({}, initialValues), { delivery: Object.assign(Object.assign({}, initialValues.delivery), { address: Object.assign(Object.assign({}, initialValues.delivery.address), { phoneNumber: CustomerUtil.convertPhoneNumberPrefix(phoneNumber, '00', '+') }) }) });
    }
    return initialValues;
};
export const createDeliveryForm = (info, data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const delivery = Object.assign({}, info);
    if (!delivery.customerDetails) {
        delivery.customerDetails = {};
    }
    const deliveryForm = {
        data: delivery,
        updateCollectStoreData: (data, selectedStore) => {
            if (deliveryForm.data.customerDetails) {
                deliveryForm.data.customerDetails.needInvoice = false;
            }
            deliveryForm.data.deliveryDate = null;
            deliveryForm.data.deliveryAddress = Object.assign(Object.assign(Object.assign({}, deliveryForm.data.deliveryAddress), data.customer.address), { addToProfile: false, idCountry: deliveryForm.data.idCountry, country: deliveryForm.data.country, firstName: data.customer.firstName, middleName: data.customer.middleName, lastName: data.customer.lastName, idTitle: data.customer.idTitle });
            if (selectedStore) {
                deliveryForm.data.store = selectedStore.storeId;
                deliveryForm.data.storeNumber = selectedStore.storeNumber;
            }
            return deliveryForm;
        },
        updatePhoneNumberData: (values) => {
            const savePhoneNumberFormValues = values.delivery.address.savePhoneNumber && values.delivery.address.phoneNumber;
            if (deliveryForm.data.customerDetails) {
                deliveryForm.data.customerDetails.mobilePhoneNumber = setCustomerDetailsPhoneNumber(savePhoneNumberFormValues
                    ? values.delivery.address.phoneNumber
                    : deliveryForm.data.customerDetails.mobilePhoneNumber);
                deliveryForm.data.customerDetails.phoneNumber = setCustomerDetailsPhoneNumber(savePhoneNumberFormValues
                    ? values.delivery.address.phoneNumber
                    : deliveryForm.data.customerDetails.mobilePhoneNumber);
            }
            deliveryForm.data.deliveryAddress.phoneNumber = setCustomerDetailsPhoneNumber(savePhoneNumberFormValues
                ? values.delivery.address.phoneNumber
                : deliveryForm.data.deliveryAddress.phoneNumber);
            return deliveryForm;
        },
        updateHomeDeliveryData: (data, selectedAddress) => {
            deliveryForm.data.deliveryAddress = selectedAddress
                ? selectedAddress
                : Object.assign(Object.assign({}, data.delivery.address), { addToProfile: data.delivery.saveAddress, phoneNumber: deliveryForm.data.deliveryAddress.phoneNumber, idCountry: deliveryForm.data.idCountry, country: deliveryForm.data.country });
            return deliveryForm;
        },
        updatePickupPointData: (data, isProviderPostNL) => {
            deliveryForm.updateCustomerDeliveryData(data);
            if (isProviderPostNL && deliveryForm.data.customerDetails) {
                deliveryForm.data.customerDetails.address = Object.assign(Object.assign({}, deliveryForm.data.customerDetails.address), { postCode: data.customer.address.postCode, houseNumber: data.customer.address.houseNumber, houseNumberAddition: data.customer.address.houseNumberAddition, address: data.customer.address.address, city: data.customer.address.city });
            }
            if (deliveryForm.data.pickupInformation) {
                deliveryForm.data.pickupInformation.properties.countryId = String(deliveryForm.data.idCountry);
            }
            return deliveryForm;
        },
        updateInvoiceData: (data) => {
            var _a, _b;
            let invoiceAddress = {};
            if ((_b = (_a = deliveryForm.data.customerDetails) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.address) {
                invoiceAddress = Object.assign({}, deliveryForm.data.customerDetails.address);
            }
            if (data.needInvoice) {
                invoiceAddress = Object.assign(Object.assign(Object.assign({}, invoiceAddress), data.invoice.address), { idCountry: deliveryForm.data.idCountry });
            }
            if (!deliveryForm.data.customerDetails) {
                return deliveryForm;
            }
            deliveryForm.data.customerDetails.invoiceAddress = invoiceAddress;
            deliveryForm.data.customerDetails.needInvoice = data.needInvoice;
            deliveryForm.data.customerDetails.alternateInvoiceAddress = data.alternateInvoiceAddress;
            if (data.alternateInvoiceAddress) {
                deliveryForm.data.customerDetails.invoiceAddress = data.invoice.address;
            }
            deliveryForm.data.customerDetails.companyDepartment = data.invoice.companyDepartment;
            deliveryForm.data.customerDetails.companyName = data.invoice.companyName;
            deliveryForm.data.customerDetails.vatNumber = data.invoice.vatNumber;
            deliveryForm.data.customerDetails.techAddress = data.invoice.techAddress;
            return deliveryForm;
        },
        updateCustomerDeliveryData: (data) => {
            deliveryForm.data.deliveryAddress = Object.assign(Object.assign({}, deliveryForm.data.deliveryAddress), { firstName: data.customer.firstName, middleName: data.customer.middleName, lastName: data.customer.lastName, idTitle: data.customer.idTitle });
            return deliveryForm;
        },
    };
    if (CustomerUtil.isUpdateNamesAndTitleForCustomerDetails(delivery)) {
        deliveryForm.data.customerDetails = Object.assign(Object.assign({}, delivery.customerDetails), { firstName: ((_a = data.customer) === null || _a === void 0 ? void 0 : _a.firstName) || ((_b = data.delivery) === null || _b === void 0 ? void 0 : _b.address.firstName), middleName: ((_c = data.customer) === null || _c === void 0 ? void 0 : _c.middleName) || ((_d = data.delivery) === null || _d === void 0 ? void 0 : _d.address.middleName), lastName: ((_e = data.customer) === null || _e === void 0 ? void 0 : _e.lastName) || ((_f = data.delivery) === null || _f === void 0 ? void 0 : _f.address.lastName), idTitle: ((_g = data.customer) === null || _g === void 0 ? void 0 : _g.idTitle) || ((_h = data.delivery) === null || _h === void 0 ? void 0 : _h.address.idTitle) });
    }
    if (deliveryForm.data.customerDetails && !((_j = deliveryForm.data.customerDetails) === null || _j === void 0 ? void 0 : _j.idTitle)) {
        deliveryForm.data.customerDetails.idTitle = ((_k = data.customer) === null || _k === void 0 ? void 0 : _k.idTitle) || ((_m = (_l = data.delivery) === null || _l === void 0 ? void 0 : _l.address) === null || _m === void 0 ? void 0 : _m.idTitle);
    }
    if (deliveryForm.data.pickupInformation) {
        deliveryForm.data.pickupInformation.properties.countryId = String(deliveryForm.data.idCountry);
    }
    return deliveryForm;
};
export const updateAddressCountryValues = (address, idCountry) => {
    if (![CountryId.NL, CountryId.BE, CountryId.LU, CountryId.FR].includes(idCountry)) {
        address.houseNumberAddition = '';
    }
    if (![CountryId.NL, CountryId.BE, CountryId.LU, CountryId.DE, CountryId.FR].includes(idCountry)) {
        address.houseNumber = '';
    }
    if ([CountryId.NL, CountryId.BE, CountryId.LU, CountryId.DE, CountryId.FR].includes(idCountry)) {
        address.addressLine2 = '';
    }
    if (![CountryId.GB, CountryId.GG, CountryId.JE].includes(idCountry)) {
        address.addressLine3 = '';
    }
    return address;
};
export const setInvoiceValues = (customerDetails, idCountry) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        needInvoice: customerDetails.needInvoice || false,
        invoice: Object.assign({}, (((_a = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.invoiceAddress) === null || _a === void 0 ? void 0 : _a.idCountry) === idCountry
            ? {
                vatCountry: ((_b = customerDetails.vatNumber) === null || _b === void 0 ? void 0 : _b.slice(0, 2)) || '',
                vatNumber: (_c = customerDetails.vatNumber) !== null && _c !== void 0 ? _c : '',
                companyName: (_d = customerDetails.companyName) !== null && _d !== void 0 ? _d : '',
                companyDepartment: (_e = customerDetails.companyDepartment) !== null && _e !== void 0 ? _e : '',
                techAddress: (_f = customerDetails.techAddress) !== null && _f !== void 0 ? _f : '',
                address: Object.assign(Object.assign({}, customerDetails.invoiceAddress), { idCountry: idCountry }),
            }
            : Object.assign(Object.assign({}, initialValuesDeliveryForm.invoice), { address: Object.assign(Object.assign({}, initialValuesDeliveryForm.invoice.address), { idCountry: idCountry }) }))),
    });
};
